import { generateId, pushNotification, getInvestigationDb, loadInvestigationDb } from './store';
import type { LocalNotificationRecord } from './types';

export async function notifyInvestigation(
  title: string,
  body: string,
  level: LocalNotificationRecord['level'] = 'info',
): Promise<void> {
  await loadInvestigationDb();
  const settings = getInvestigationDb().settings;

  const record: LocalNotificationRecord = {
    id: generateId('notif'),
    at: Date.now(),
    title,
    body,
    read: false,
    level,
  };
  await pushNotification(record);

  if (settings.browserNotifications && typeof Notification !== 'undefined') {
    if (Notification.permission === 'granted') {
      new Notification(title, { body });
    } else if (Notification.permission !== 'denied') {
      const perm = await Notification.requestPermission();
      if (perm === 'granted') {
        new Notification(title, { body });
      }
    }
  }

  if (settings.soundAlerts && level === 'alert') {
    try {
      const ctx = new AudioContext();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = 880;
      gain.gain.value = 0.05;
      osc.start();
      osc.stop(ctx.currentTime + 0.15);
    } catch {
      // ignore
    }
  }
}
